import React from "react";

const MoneyIcon = ({ className = "", size = 24, color = "#1F2937" }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="3" y="6" width="18" height="12" rx="2" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="2.5" stroke={color} strokeWidth="1.5" />
    <path
      d="M3 10c1.5 0 2.5-1 2.5-2.5M21 10c-1.5 0-2.5-1-2.5-2.5M3 14c1.5 0 2.5 1 2.5 2.5M21 14c-1.5 0-2.5 1-2.5 2.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default MoneyIcon;
